import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "maxBatteryCapacity",
    "maxBatteryRange",
    "select"
  ];

  connect() {
    this.sync(false);
  }

  change() {
    this.sync(true);
  }

  get selectedModelOption() {
    return this.selectTarget.selectedOptions[0];
  }

  sync(overwrite = true) {
    const { selectedModelOption } = this;

    if (!selectedModelOption) return;

    const { maxBatteryCapacity, maxBatteryRange } = selectedModelOption.dataset;

    if (overwrite || this.maxBatteryCapacityTarget.value === "") {
      this.populateInput(this.maxBatteryCapacityTarget, maxBatteryCapacity);

      if (this.hasMaxBatteryRangeTarget) {
        this.populateInput(this.maxBatteryRangeTarget, maxBatteryRange);
      }
    }
  }

  populateInput(inputElement, value) {
    const intValue = parseInt(value);

    if (Number.isNaN(intValue)) {
      return;
    }

    value = intValue.toString();

    if (inputElement.value === value) {
      return;
    }

    inputElement.value = value;
    inputElement.dispatchEvent(new Event('change'));
    inputElement.dispatchEvent(new Event('input'));
  }
}
